module.exports = __webpack_public_path__ + "img/Procedures.9b483232.svg";